var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRoundAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8334H10.8333V15.0001C10.8333 15.4584 10.4583 15.8334 9.99996 15.8334C9.54163 15.8334 9.16663 15.4584 9.16663 15.0001V10.8334H4.99996C4.54163 10.8334 4.16663 10.4584 4.16663 10.0001C4.16663 9.54175 4.54163 9.16675 4.99996 9.16675H9.16663V5.00008C9.16663 4.54175 9.54163 4.16675 9.99996 4.16675C10.4583 4.16675 10.8333 4.54175 10.8333 5.00008V9.16675H15C15.4583 9.16675 15.8333 9.54175 15.8333 10.0001C15.8333 10.4584 15.4583 10.8334 15 10.8334Z",
    fill: "#2B6ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundAdd);
export default __webpack_public_path__ + "static/media/ic_round-add.c5560f0eb9c84c1238353ccbea6edc81.svg";
export { ForwardRef as ReactComponent };